/**
 * Application Configuration
 * Centralized config for easy adjustments
 */

const config = {
  // Cloud Storage Configuration
  cloudStorage: {
    // Set to null or Infinity for unlimited
    // Set to a number (5, 10, etc.) for a limit
    maxPlans: null,  // ← Change this! null = unlimited, 5 = 5 plans max
    
    // Display name for the limit (used in UI messages)
    get displayLimit() {
      return this.maxPlans === null || this.maxPlans === Infinity 
        ? 'Unlimited' 
        : this.maxPlans;
    },
    
    // Check if unlimited
    get isUnlimited() {
      return this.maxPlans === null || this.maxPlans === Infinity;
    }
  },
  
  // Local Storage Configuration
  localStorage: {
    maxPlans: 5,  // Keep 5 most recent plans in browser storage
    maxSizeMB: 5  // Browser localStorage limit
  },
  
  // API Configuration
  api: {
    maxPlanSizeMB: 10,  // Max size per plan in cloud
    retryAttempts: 3,
    retryDelayMs: 500
  },
  
  // Feature Flags
  features: {
    authentication: false,  // Set to true when Firebase Auth is implemented
    realTimeTracking: false,
    pdfExport: false
  }
};

export default config;

